import { Injectable } from '@angular/core';

interface LockoutState {
  failedAttempts: number;
  lastFailedAt: number;
  lockoutUntil?: number;
}

@Injectable({
  providedIn: 'root'
})
export class LockoutService {
  private readonly KEY_PREFIX = 'lockout_';

  getState(username: string): LockoutState {
    const raw = localStorage.getItem(this.KEY_PREFIX + username);
    if (!raw) return { failedAttempts: 0, lastFailedAt: 0 };
    return JSON.parse(raw);
  }

  saveState(username: string, state: LockoutState) {
    localStorage.setItem(this.KEY_PREFIX + username, JSON.stringify(state));
  }

  reset(username: string) {
    localStorage.removeItem(this.KEY_PREFIX + username);
  }

  recordFailure(username: string): number {
    const state = this.getState(username);
    const now = Date.now();

    // Reset if last failure was more than 15 minutes ago
    if (now - state.lastFailedAt > 15 * 60 * 1000) {
      state.failedAttempts = 1;
    } else {
      state.failedAttempts += 1;
    }

    state.lastFailedAt = now;

    const n = state.failedAttempts;
    if (n >= 5) {
      const lockoutSecs = Math.pow(2, n - 5);
      state.lockoutUntil = now + lockoutSecs * 1000;
    } else {
      state.lockoutUntil = undefined;
    }

    this.saveState(username, state);
    return state.lockoutUntil ? Math.ceil((state.lockoutUntil - now) / 1000) : 0;
  }

  isLocked(username: string): number {
    const state = this.getState(username);
    const now = Date.now();

    if (state.lockoutUntil && now < state.lockoutUntil) {
      return Math.ceil((state.lockoutUntil - now) / 1000);
    }

    return 0;
  }
}

